import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DESOS_Records_List, DESOS_Outcomes, DESOS_Individuals, DESOS_Search_Fields } from 'src/app/dataentry/dataentry';
import { Router, RouterModule } from '@angular/router';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TempDataService } from 'src/app/services/temp-data.service';
import { DataentryService } from 'src/app/services/dataentry.service';

@Component({
  selector: 'app-duplicate-records',
  templateUrl: './duplicate-records.component.html',
  styleUrls: ['./duplicate-records.component.css']
})
export class DuplicateRecordsComponent implements OnInit {
  @Input() duplicates: DESOS_Records_List[] = [];
  @Output() cancel = new EventEmitter<void>();
  @Output() proceed = new EventEmitter<string>();
  public displayedColumns: string[] = ['action', 'name', 'city', 'county', 'dateOfBirth', 'gender', 'race'];
  public desosreportinfo: any;

  // Hold async results if needed.
  private asyncOutcomesResult: DESOS_Outcomes;
  private asyncIndividualResult: DESOS_Individuals;

  constructor(
    private router: Router,
    private http: HttpClient,
    private authentication: AuthenticationService,
    private tempdata: TempDataService,
    private APIservices: DataentryService
  ) { }

  ngOnInit() {
    this.desosreportinfo = this.authentication.getReport();
    if (this.duplicates && this.duplicates.length > 1) {
      let latestItem = this.duplicates[0];
      let latestDate = this.parseUserEditDate(latestItem.user_Edit);

      for (const item of this.duplicates) {
        const currentDate = this.parseUserEditDate(item.user_Edit);
        if (currentDate > latestDate) {
          latestDate = currentDate;
          latestItem = item;
        }
      }
      this.duplicates = [latestItem];
    }
  }
  private parseUserEditDate(userEdit: string): number {
    if (!userEdit) {
      return 0;
    }
    const parts = userEdit.split('~');
    if (parts.length < 2) {
      return 0;
    }
    const dt = new Date(parts[1]);
    return dt.getTime() || 0; // return as numeric timestamp
  }
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async handleEditRecord(recordId: string, individualId: string) {
    const inparams = new HttpParams().set('strRecordId', recordId);
    await this.getAsyncOutcomesData(inparams);
    const inparams1 = new HttpParams().set('strIndividualId', individualId);
    await this.getAsyncIndividualData(inparams1);

    this.tempdata.setRosterAction("edit");
    await this.delay(3000);
    this.reloadComponent();
  }

  async handleNewOutcome(recordId: string, individualId: string) {
    const inparams = new HttpParams().set('strRecordId', recordId);
    await this.getAsyncOutcomesData(inparams);
    const inparams1 = new HttpParams().set('strIndividualId', individualId);
    await this.getAsyncIndividualData(inparams1);

    this.tempdata.setRosterAction("copy");
    await this.delay(3000);
    this.reloadComponent();
  }
  reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.router.url]);
  }
  async getAsyncOutcomesData(inparam: HttpParams): Promise<void> {
    try {
      this.asyncOutcomesResult = await this.APIservices.getOutcomeById(inparam).toPromise();
      if (this.asyncOutcomesResult != null) {
        this.tempdata.setCurrentoutcome(this.asyncOutcomesResult);
      } else {
        alert("Invalid Outcomes ID.");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getAsyncIndividualData(inparam: HttpParams): Promise<void> {
    try {
      this.asyncIndividualResult = await this.APIservices.getIndivitualById(inparam).toPromise();
      if (this.asyncIndividualResult != null) {
        this.tempdata.setCurrentindivitual(this.asyncIndividualResult);
      } else {
        alert("Invalid Individual ID.");
      }
    } catch (error) {
      console.error(error);
    }
  }
  onCancel() {
    this.cancel.emit();
  }

  onProceed() {
    this.proceed.emit();
  }

  splitUserEdit(userEdit, indexNum) {
    var array: string[] = userEdit.split("~");
    if (typeof array[0] === 'undefined') array[0] = "";
    if (typeof array[1] === 'undefined') array[1] = "";
    return array[indexNum];
  }
}
